import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { DropdownModal, ListItemSection, ListItemSelect } from 'wix-rich-content-toolbars-ui';

import { POLLS_DROPDOWN_CUSTOMIZE_LAYOUT } from '../dataHooks';
import { layoutData } from './PollButtonsData';

type Props = {
  getSelectedLayout: () => string;
  onClick: (commandKey: string) => void;
  onCustomizeButtonClick: () => void;
};

const PollLayoutPanel: React.FC<Props> = ({
  getSelectedLayout,
  onClick,
  onCustomizeButtonClick,
}) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};

  const onKeyDown = (e, onClick) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick();
      e.stopPropagation();
    }
  };

  const CustomizeButton = (
    <>
      <ListItemSection type={'divider'} />
      <ListItemSelect
        title={t('Poll_Mobile_Editor_Toolbar_Customize')}
        onClick={onCustomizeButtonClick}
        dataHook={POLLS_DROPDOWN_CUSTOMIZE_LAYOUT}
        onKeyDown={e => onKeyDown(e, onCustomizeButtonClick)}
      />
    </>
  );

  const LayoutButtons = layoutData.map(({ dataHook, icon: Icon, text, commandKey }) => {
    const onButtonClick = () => onClick(commandKey);
    return (
      <ListItemSelect
        key={commandKey}
        title={t(text)}
        dataHook={dataHook}
        prefix={<Icon />}
        selected={commandKey === getSelectedLayout()}
        onClick={onButtonClick}
        onKeyDown={e => onKeyDown(e, onButtonClick)}
      />
    );
  });

  const DropdownOptions = [...LayoutButtons, CustomizeButton];

  return <DropdownModal options={DropdownOptions} jsdomMode={jsdomMode} />;
};

export default PollLayoutPanel;
